import React from 'react';
import PropTypes from 'prop-types';

const NoResults = ({ title, desc }) => (
  <div className="noResults">
    <div className="title">
      <img className="exclamationIcon" src="/dp-air/img/icons/exclamation.png" />
      <div className="titleText">{title}</div>
    </div>
    <div className="desc" dangerouslySetInnerHTML={{ __html: desc }} />
  </div>
);

NoResults.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};

export default NoResults;
